import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { RouteConfig } from 'vue-router'
import { customObjectsRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'
const CustomObjectsListPage = () =>
  import(/* webpackChunkName: "opportunities" */ '@/pmd/pages/CustomObjects/CustomObjectsListPage.vue')
const CustomObjectManageSmartLists = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectManageSmartLists.vue')

const CustomObjectsBulkActions = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectsBulkActions.vue')

export const customObjectsRoutes: RouteConfig[] = [
  {
    path: 'objects/:custom_objects_key',
    name: customObjectsRouteNames.default,
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'list',
        name: customObjectsRouteNames.list,
        component: CustomObjectsListPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':smartlist_id',
            name: 'custom-object-view-smartlist',
            component: CustomObjectsListPage,
          },
        ],
      },
      {
        path: 'smartlists',
        name: 'custom-object-manage-smartlists',
        component: CustomObjectManageSmartLists,
      },
      {
        path: 'bulk-actions',
        name: 'custom-object-bulk-actions',
        component: CustomObjectsBulkActions,
      },
    ],
  },
]
